<template>
  <div>
    <only-site-card :com_data="com_data">
      <template v-slot:item_edit>
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">女の子へ質問</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row v-for="i in 7" :key="i">
                  <v-col cols="12" md="6">
                    <v-text-field
                      ref="refQuestion"
                      v-model="cast_prop[items[`questions_` + i].item_id]"
                      :name="items[`questions_` + i].item_id"
                      :label="items[`questions_` + i].text"
                      success
                      outlined
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      ref="refAanswer"
                      v-model="cast_prop[items[`answers_` + i].item_id]"
                      :name="items[`answers_` + i].item_id"
                      :label="items[`answers_` + i].text"
                      success
                      outlined
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </template>
    </only-site-card>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import utilFunc from "@/common/utilFunc.js";

export default defineComponent({
  props: ["com_data"],
  setup(props, ctx) {
    const CastPropsRepository = repositoryFactory.get("castProps");
    const refQuestion = ref();
    const refAanswer = ref();
    const state = reactive({
      errorElement: null,
      items: {},
      cast_prop: {},
      // 読み込み時データ保持(保存前比較用)
      keepData: {
        cast_prop: {},
      },
    });

    const init = async () => {
      // cast_propにキーを設定(質問・回答とも編集可。文字数制限はサイト準拠で設けない)
      state.items = {};
      for (let i = 1; i <= 7; i++) {
        state.items["questions_" + i] = {
          item_id: "questions_" + i,
          text: "質問" + i,
          rules: "",
          counter: "",
        };
        state.items["answers_" + i] = {
          item_id: "answers_" + i,
          text: "回答" + i,
          rules: "",
          counter: "",
        };
      }
      for (let key in state.items) {
        set(state.cast_prop, key, null);
      }
      Object.keys(props.com_data.cast_prop).forEach(function (key) {
        set(state.cast_prop, key, props.com_data.cast_prop[key]);
      });
      // 読み込み時のデータを保持(保存前に比較するため)
      state.keepData.cast_prop = Object.assign({}, state.cast_prop);
    };

    init();

    // チェック処理
    const checkValid = async () => {
      state.errorElement = null;
      return await ctx.refs.observer.validate();
    };

    const setErrorFocus = async () => {
      if (!state.errorElement) return;
      setTimeout(() => {
        state.errorElement.scrollIntoView({
          block: "center",
        });
      }, 300);
    };

    // 保存処理
    const save = async () => {
      if (!utilFunc.compareObject(state.keepData.cast_prop, state.cast_prop)) {
        const prop_param = [];
        for (let key in state.cast_prop) {
          prop_param.push({
            cast_id: props.com_data.cast_id,
            key: props.com_data.prefix + "__" + key,
            value: state.cast_prop[key] ?? "",
          });
        }
        await CastPropsRepository.save_all({ cast_prop: prop_param })
          .then((response) => {
            if (response.data) {
              // データ追加OK
            }
          })
          .catch((error) => {
            throw (
              "ERROR:ddeli.vue/save CastPropsRepository.save_all (" +
              error +
              ")"
            );
          });
      }
      return true;
    };

    return {
      props,
      setting,
      refQuestion,
      refAanswer,
      ...toRefs(state),
      checkValid,
      setErrorFocus,
      save,
    };
  },
});
</script>

<style scoped></style>
